import { useEffect, useState } from 'react';

import { useLocation, useParams } from 'react-router-dom';

import useTheme from 'api/useTheme';

import { defaultStoreSettings } from './defaults';
import { StoreSettingsFormValues } from './generalTheme.types';

export const useGetStoreSettingsInitialValues = () => {
  const location = useLocation();
  const { publisherId } = useParams();

  const [initialValues, setInitialValue] =
    useState<StoreSettingsFormValues>(defaultStoreSettings);
  const { getGeneralTheme: generalTheme } = useTheme(publisherId);

  useEffect(() => {
    setInitialValue({
      productsQuantityFormat: {
        milSeparator:
          generalTheme.data?.productsQuantityFormat?.milSeparator ||
          defaultStoreSettings.productsQuantityFormat.milSeparator,
        fractionalSeparator:
          generalTheme.data?.productsQuantityFormat?.fractionalSeparator ||
          defaultStoreSettings.productsQuantityFormat.fractionalSeparator,
        thousandShorthand:
          generalTheme.data?.productsQuantityFormat?.thousandShorthand ||
          defaultStoreSettings.productsQuantityFormat.thousandShorthand,
        millionShorthand:
          generalTheme.data?.productsQuantityFormat?.millionShorthand ||
          defaultStoreSettings.productsQuantityFormat.millionShorthand,
        billionShorthand:
          generalTheme.data?.productsQuantityFormat?.billionShorthand ||
          defaultStoreSettings.productsQuantityFormat.billionShorthand,
        trillionShorthand:
          generalTheme.data?.productsQuantityFormat?.trillionShorthand ||
          defaultStoreSettings.productsQuantityFormat.trillionShorthand,
        quadrillionShorthand:
          generalTheme.data?.productsQuantityFormat?.quadrillionShorthand ||
          defaultStoreSettings.productsQuantityFormat.quadrillionShorthand,
        quintillionShorthand:
          generalTheme.data?.productsQuantityFormat?.quintillionShorthand ||
          defaultStoreSettings.productsQuantityFormat.quintillionShorthand,
        digitsBasedAbbreviation:
          generalTheme.data?.productsQuantityFormat?.digitsBasedAbbreviation ||
          defaultStoreSettings.productsQuantityFormat.digitsBasedAbbreviation,
        maxDigitsWithoutShorthand:
          generalTheme.data?.productsQuantityFormat
            ?.maxDigitsWithoutShorthand ||
          defaultStoreSettings.productsQuantityFormat.maxDigitsWithoutShorthand
      },
      balanceQuantityFormat: {
        milSeparator:
          generalTheme.data?.balanceQuantityFormat?.milSeparator ||
          defaultStoreSettings.balanceQuantityFormat.milSeparator,
        fractionalSeparator:
          generalTheme.data?.balanceQuantityFormat?.fractionalSeparator ||
          defaultStoreSettings.balanceQuantityFormat.fractionalSeparator,
        thousandShorthand:
          generalTheme.data?.balanceQuantityFormat?.thousandShorthand ||
          defaultStoreSettings.balanceQuantityFormat.thousandShorthand,
        millionShorthand:
          generalTheme.data?.balanceQuantityFormat?.millionShorthand ||
          defaultStoreSettings.balanceQuantityFormat.millionShorthand,
        billionShorthand:
          generalTheme.data?.balanceQuantityFormat?.billionShorthand ||
          defaultStoreSettings.balanceQuantityFormat.billionShorthand,
        trillionShorthand:
          generalTheme.data?.balanceQuantityFormat?.trillionShorthand ||
          defaultStoreSettings.balanceQuantityFormat.trillionShorthand,
        quadrillionShorthand:
          generalTheme.data?.balanceQuantityFormat?.quadrillionShorthand ||
          defaultStoreSettings.balanceQuantityFormat.quadrillionShorthand,
        quintillionShorthand:
          generalTheme.data?.balanceQuantityFormat?.quintillionShorthand ||
          defaultStoreSettings.balanceQuantityFormat.quintillionShorthand,
        digitsBasedAbbreviation:
          generalTheme.data?.balanceQuantityFormat?.digitsBasedAbbreviation ||
          defaultStoreSettings.balanceQuantityFormat.digitsBasedAbbreviation,
        maxDigitsWithoutShorthand:
          generalTheme.data?.balanceQuantityFormat?.maxDigitsWithoutShorthand ||
          defaultStoreSettings.balanceQuantityFormat.maxDigitsWithoutShorthand
      },
      specialOfferQuantityFormat: {
        milSeparator:
          generalTheme.data?.specialOfferQuantityFormat?.milSeparator ||
          defaultStoreSettings.specialOfferQuantityFormat.milSeparator,
        fractionalSeparator:
          generalTheme.data?.specialOfferQuantityFormat?.fractionalSeparator ||
          defaultStoreSettings.specialOfferQuantityFormat.fractionalSeparator,
        thousandShorthand:
          generalTheme.data?.specialOfferQuantityFormat?.thousandShorthand ||
          defaultStoreSettings.specialOfferQuantityFormat.thousandShorthand,
        millionShorthand:
          generalTheme.data?.specialOfferQuantityFormat?.millionShorthand ||
          defaultStoreSettings.specialOfferQuantityFormat.millionShorthand,
        billionShorthand:
          generalTheme.data?.specialOfferQuantityFormat?.billionShorthand ||
          defaultStoreSettings.specialOfferQuantityFormat.billionShorthand,
        trillionShorthand:
          generalTheme.data?.specialOfferQuantityFormat?.trillionShorthand ||
          defaultStoreSettings.specialOfferQuantityFormat.trillionShorthand,
        quadrillionShorthand:
          generalTheme.data?.specialOfferQuantityFormat?.quadrillionShorthand ||
          defaultStoreSettings.specialOfferQuantityFormat.quadrillionShorthand,
        quintillionShorthand:
          generalTheme.data?.specialOfferQuantityFormat?.quintillionShorthand ||
          defaultStoreSettings.specialOfferQuantityFormat.quintillionShorthand,
        digitsBasedAbbreviation:
          generalTheme.data?.specialOfferQuantityFormat
            ?.digitsBasedAbbreviation ||
          defaultStoreSettings.specialOfferQuantityFormat
            .digitsBasedAbbreviation,
        maxDigitsWithoutShorthand:
          generalTheme.data?.specialOfferQuantityFormat
            ?.maxDigitsWithoutShorthand ||
          defaultStoreSettings.specialOfferQuantityFormat
            .maxDigitsWithoutShorthand
      },
      rollingOfferQuantityFormat: {
        milSeparator:
          generalTheme.data?.rollingOfferQuantityFormat?.milSeparator ||
          defaultStoreSettings.rollingOfferQuantityFormat.milSeparator,
        fractionalSeparator:
          generalTheme.data?.rollingOfferQuantityFormat?.fractionalSeparator ||
          defaultStoreSettings.rollingOfferQuantityFormat.fractionalSeparator,
        thousandShorthand:
          generalTheme.data?.rollingOfferQuantityFormat?.thousandShorthand ||
          defaultStoreSettings.rollingOfferQuantityFormat.thousandShorthand,
        millionShorthand:
          generalTheme.data?.rollingOfferQuantityFormat?.millionShorthand ||
          defaultStoreSettings.rollingOfferQuantityFormat.millionShorthand,
        billionShorthand:
          generalTheme.data?.rollingOfferQuantityFormat?.billionShorthand ||
          defaultStoreSettings.rollingOfferQuantityFormat.billionShorthand,
        trillionShorthand:
          generalTheme.data?.rollingOfferQuantityFormat?.trillionShorthand ||
          defaultStoreSettings.rollingOfferQuantityFormat.trillionShorthand,
        quadrillionShorthand:
          generalTheme.data?.rollingOfferQuantityFormat?.quadrillionShorthand ||
          defaultStoreSettings.rollingOfferQuantityFormat.quadrillionShorthand,
        quintillionShorthand:
          generalTheme.data?.rollingOfferQuantityFormat?.quintillionShorthand ||
          defaultStoreSettings.rollingOfferQuantityFormat.quintillionShorthand,
        digitsBasedAbbreviation:
          generalTheme.data?.rollingOfferQuantityFormat
            ?.digitsBasedAbbreviation ||
          defaultStoreSettings.rollingOfferQuantityFormat
            .digitsBasedAbbreviation,
        maxDigitsWithoutShorthand:
          generalTheme.data?.rollingOfferQuantityFormat
            ?.maxDigitsWithoutShorthand ||
          defaultStoreSettings.rollingOfferQuantityFormat
            .maxDigitsWithoutShorthand
      }
    });
  }, [generalTheme.data, location]);

  return { initialValues };
};
